type DefaultOption = {
  id: number
  value: string
  minDiversity: number
  minLength: number
}

type DiversityType = "lowercase" | "uppercase" | "symbol" | "number"

type Strength = {
  id: number
  value: string
  contains: DiversityType[]
  length: number
}

const defaultOptions: DefaultOption[] = [
  {
    id: 0,
    value: "Sehr schwach",
    minDiversity: 0,
    minLength: 0
  },
  {
    id: 1,
    value: "Schwach",
    minDiversity: 2,
    minLength: 6
  },
  {
    id: 2,
    value: "Mittel",
    minDiversity: 4,
    minLength: 8
  },
  {
    id: 3,
    value: "Stark",
    minDiversity: 4,
    minLength: 10
  }
]


export const passwordStrength: (password: string) => Strength = (password: string, options = defaultOptions, allowedSymbols = "!\"#\$%&'\(\)\*\+,-\./:;<=>\?@\[\\\\\\]\^_`\{|\}~") => {
  let passwordCopy = password || ''

  const rules = [
    {
      regex: "[a-z]",
      message: 'lowercase'
    },
    {
      regex: '[A-Z]',
      message: 'uppercase'
    },
    {
      regex: '[0-9]',
      message: 'number'
    },
  ]

  if (allowedSymbols) {
    rules.push({
      regex: `[${allowedSymbols}]`,
      message: 'symbol'
    })
  }

  let strength: any = {}

  strength.contains = rules
    .filter(rule => new RegExp(`${rule.regex}`).test(passwordCopy))
    .map(rule => rule.message)

  strength.length = passwordCopy.length;

  let fulfilledOptions = options
    .filter(option => strength.contains.length >= option.minDiversity)
    .filter(option => strength.length >= option.minLength)
    .sort((o1, o2) => o2.id - o1.id)
    .map(option => ({ id: option.id, value: option.value }))

  Object.assign(strength, fulfilledOptions[0])

  return strength;
}